// @ts-ignore
import PhotoSwipeLightbox from 'photoswipe/lightbox';
import { useEffect, useRef } from 'react';

import { closeSVGString, zoomSVGString } from '@/lib/const';
import { theme } from '@/theme';

export const usePhotoSwipe = (
  isReady: boolean,
  gallery: string | undefined,
) => {
  const lightboxRef = useRef<PhotoSwipeLightbox | null>(null) as {
    current: PhotoSwipeLightbox | null;
  };

  useEffect(() => {
    if (gallery && isReady) {
      const stringifiedGallery = `#${gallery}`;
      lightboxRef.current = new PhotoSwipeLightbox({
        gallery: stringifiedGallery,
        pswpModule: () => import('photoswipe'),
        bgOpacity: 1,
        showHideAnimationType: 'fade',
        children: 'a',
        closeSVG: closeSVGString,
        zoomSVG: zoomSVGString,
      });
      lightboxRef.current.init();
      lightboxRef.current.on('afterInit', () => {
        const counterElement = document.querySelector('.pswp__counter');
        if (counterElement instanceof HTMLElement) {
          counterElement.style.color = theme.colors.default;
          counterElement.style.textShadow = 'none';
        }
      });

      return () => {
        lightboxRef?.current?.destroy();
        lightboxRef.current = null;
      };
    }
  }, [isReady]);

  return { gallery, lightbox: lightboxRef };
};
